import { Toaster } from "react-hot-toast";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
        }}
      />
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </>
  );
}

export default App;
